import React from 'react'
import ReactPaginate from 'react-paginate';

const UserTable = ({ users, handleSelectAll, selectedIds, handleSelectUser, keyword, setKeyWord, total, size, handlePageClick }) => {
  return (
    <>
      <div className="border h-full rounded-lg bg-white border-[#2121211A]/10">
        <div className="flex justify-between items-center px-6 py-2 border-b">
          <h2 className="text-xl font-semibold">Customer List </h2>
          <input type="text" placeholder="Search" value={keyword} onChange={(e) => setKeyWord(e.target.value)} className="px-2 py-1 border border-[#D8D8D8] rounded focus:outline-none focus:ring" />
        </div>
        <div className="overflow-x-auto px-6 py-4">
          <table className="min-w-full text-sm text-left text-gray-500  border ">
            <thead className="text-black capitalize border-b bg-gray-100">
              <tr className="whitespace-nowrap border-b">
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200 ">
                  <label className='flex items-center space-x-2'>
                    <input type="checkbox" className='border border-[#D8D8D8]' onChange={handleSelectAll}
                      checked={users && Array.isArray(users) && users.every(user => selectedIds.includes(user.id))} />
                    <span> Name</span>
                  </label>
                </th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Weighbridge Id</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">License Key</th>
                <th className="px-4 py-2 whitespace-nowrap space-x-3 font-medium text-gray-900 cursor-pointer hover:bg-gray-200">Phone</th>
              </tr>
            </thead>
            <tbody>
              {users && users.length > 0 ? users?.map((user, index) => (
                <tr key={index} className="bg-white whitespace-nowrap hover:bg-gray-50 font-normal text-[#212121] border-b capitalize">
                  <td className="px-4 py-2 whitespace-nowrap flex items-center gap-2 capitalize">
                    <input type="checkbox" className='border border-[#D8D8D8]'
                      checked={selectedIds?.includes(user.id)}
                      onChange={() => handleSelectUser(user.id)}
                    />
                    {user.f_name}
                  </td>
                  <td className="px-4 py-2 whitespace-nowrap">{user.weighbridge_id}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{user.license_key}</td>
                  <td className="px-4 py-2 whitespace-nowrap">{user.phone}</td>
                </tr>
              )) : (<div className='text-center w-full'>No Data Found</div>)}
            </tbody>
          </table>
        </div>
        {total && total > size &&
          <div className='px-6 py-4'>
            <ReactPaginate
              previousLabel={'Prev'}
              nextLabel={'Next'}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={total / size}
              marginPagesDisplayed={1}
              pageRangeDisplayed={1}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              pageClassName={'page-cls'}
              activeClassName={'active'}
              total={total}
              size={size}
            />
          </div>}

      </div>

    </>
  )
}

export default UserTable